var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModerateImpairment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_10",
    "data-name": 10,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 112,
    height: 112,
    rx: 21,
    transform: "translate(499 56.076)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_5_",
    "data-name": "svgexport-6 (5)",
    transform: "translate(517.685 74.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12761",
    "data-name": "Path 12761",
    d: "M106.679,2,79.817,24.386,93.248,37.817,44,55.725,66.385,33.34,57.431,19.908Z",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -51.917, 45.349)",
    fill: "#f7c244"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10629",
    "data-name": "Group 10629",
    transform: "translate(-6.707 16.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12763",
    "data-name": "Path 12763",
    d: "M56.53,49.5,52.293,45.26l3-3a1.241,1.241,0,0,0,0-1.753,7.243,7.243,0,0,1,0-10.236,1.238,1.238,0,0,0,0-1.75,7.243,7.243,0,0,1,0-10.236l3-3,4.237,4.237-3,3a1.241,1.241,0,0,0,0,1.753,7.243,7.243,0,0,1,0,10.236,1.238,1.238,0,0,0,0,1.75,7.243,7.243,0,0,1,0,10.236Z",
    transform: "translate(4.914 -15.292)",
    fill: "#bce4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12764",
    "data-name": "Path 12764",
    d: "M60.53,49.5,56.293,45.26l3-3a1.241,1.241,0,0,0,0-1.753,7.243,7.243,0,0,1,0-10.236,1.238,1.238,0,0,0,0-1.75,7.243,7.243,0,0,1,0-10.236l3-3,4.237,4.237-3,3a1.241,1.241,0,0,0,0,1.753,7.243,7.243,0,0,1,0,10.236,1.238,1.238,0,0,0,0,1.75,7.243,7.243,0,0,1,0,10.236Z",
    transform: "translate(12.9 -15.292)",
    fill: "#bce4f8"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerateImpairment);
export default __webpack_public_path__ + "static/media/moderateImpairment.446efd19f83d1a2dd19315faa04bb018.svg";
export { ForwardRef as ReactComponent };